import type { SessionStatus } from '@sbc/domain-models/agents';

import { Badge } from '@/components/ui/badge';

const VARIANT: Record<SessionStatus, 'secondary' | 'default' | 'destructive' | 'outline'> = {
  idle: 'secondary',
  running: 'default',
  failed: 'destructive',
  // Outline, not destructive: an interrupted run is paused and resumable, and colouring it
  // like a failure would send an operator hunting for a fault that is not there.
  interrupted: 'outline',
};

export function StatusBadge({ status }: { status: SessionStatus }) {
  return <Badge variant={VARIANT[status]}>{status}</Badge>;
}
